module.exports = __webpack_public_path__ + "static/media/wateraid_1-min.5d5bb404.png";